<template>
  <div class="about-container" ref="container">
    <div class="info">关于我功能暂时没有做哦</div>
    <!-- <iframe class="about-content" :src="data.data.data" frameborder="0" v-if="data"></iframe> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: mapState('about', ['data', 'loading']),
  created() {
    this.$store.dispatch('about/getData')
  }
}
</script>

<style lang="less" scoped>
.about-container {
  text-align: center;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .about-content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
  }
}

.info {
  margin-top: 450px;
  color: #666;
}
</style>